import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CheckboxMenu from './CheckboxMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, CheckboxMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/menus/demos/checkbox/CheckboxMenu.tsx",
    "fileName": "CheckboxMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Paper from '@mui/material/Paper';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport Check from '@mui/icons-material/Check';\n\nconst options = ['Show toolbar', 'Show sidebar', 'Show status bar'];\n\nexport default function CheckboxMenu() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [checked, setChecked] = React.useState<Record<string, boolean>>({\n    'Show toolbar': true,\n  });\n\n  const handleToggle = (option: string) => () => {\n    setChecked((prev) => ({ ...prev, [option]: !prev[option] }));\n  };\n\n  return (\n    <Paper sx={{ width: 320, maxWidth: '100%' }}>\n      <MenuList>\n        {options.map((option) => (\n          <MenuItem\n            key={option}\n            role=\"menuitemcheckbox\"\n            selected={Boolean(checked[option])}\n            onClick={handleToggle(option)}\n          >\n            <ListItemIcon>\n              {checked[option] ? <Check fontSize=\"small\" /> : null}\n            </ListItemIcon>\n            <ListItemText>{option}</ListItemText>\n          </MenuItem>\n        ))}\n      </MenuList>\n    </Paper>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 39,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Paper from '@mui/material/Paper';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport Check from '@mui/icons-material/Check';\n\nconst options = ['Show toolbar', 'Show sidebar', 'Show status bar'];\n\nexport default function CheckboxMenu() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [checked, setChecked] = React.useState<Record<string, boolean>>({\n    'Show toolbar': true,\n  });\n\n  const handleToggle = (option: string) => () => {\n    setChecked((prev) => ({ ...prev, [option]: !prev[option] }));\n  };\n\n  return (\n    <Paper sx={{ width: 320, maxWidth: '100%' }}>\n      <MenuList>\n        {options.map((option) => (\n          <MenuItem\n            key={option}\n            role=\"menuitemcheckbox\"\n            selected={Boolean(checked[option])}\n            onClick={handleToggle(option)}\n          >\n            <ListItemIcon>\n              {checked[option] ? <Check fontSize=\"small\" /> : null}\n            </ListItemIcon>\n            <ListItemText>{option}</ListItemText>\n          </MenuItem>\n        ))}\n      </MenuList>\n    </Paper>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 39,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Paper",
      "@mui/material/MenuList",
      "@mui/material/MenuItem",
      "@mui/material/ListItemText",
      "@mui/material/ListItemIcon",
      "@mui/icons-material/Check"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
